export default __webpack_public_path__ + "static/media/support-team-marcia.51cae8e0.png";